export default function BuyAgainModal({orderId, productList, onClose, onConfirm }: { orderId: number; productList: any[]; onClose: () => void; onConfirm: () => void }) {
    return (
        <div
            role="presentation"
            className="undefined styles_modalItem__YKbSY"
            style={{
                position: "fixed",
                zIndex: 1300,
                inset: "0px",
            }}
        >
            {/* Backdrop (click để đóng) */}
            <div
                aria-hidden="true"
                onClick={onClose}
                style={{
                    zIndex: -1,
                    position: "fixed",
                    inset: "0px",
                    backgroundColor: "rgba(0,0,0,0.5)",
                }}
            />

            <div className="style_confirm_modal_wrap__ZgmeA style_confirm_modal_wrap_welcomeBack__t8I3N">
                <div style={{ textAlign: "center" }}>
                    <p className="MuiTypography-root style_modal_title__2G9R7 MuiTypography-body1">
                        Mua đơn hàng lần nữa!
                    </p>
                    <p className="MuiTypography-root style_modal_content__KTErm MuiTypography-body1">
                        Bạn có muốn thêm {productList.length} sản phẩm trong đơn hàng {orderId} vào lại giỏ hàng hiện tại!
                    </p>
                </div>

                <div
                    style={{
                        marginTop: "16px",
                        display: "flex",
                        justifyContent: "center",
                        gap: "0.5em",
                    }}
                >
                    {/* Không */}
                    <button
                        className="MuiButton-root MuiButton-contained MuiButton-containedPrimary MuiButton-sizeMedium MuiButton-containedSizeMedium MuiButtonBase-root style_defaultBtn__mZIUX style_font_gg__R9o9V css-1hw9j7s"
                        onClick={onClose}
                        type="button"
                    >
                        KHÔNG
                    </button>

                    {/* Thêm vào giỏ */}
                    <button
                        className="MuiButton-root MuiButton-contained MuiButton-containedSuccess MuiButton-sizeMedium MuiButton-containedSizeMedium MuiButtonBase-root style_font_gg__R9o9V css-5zrdtn"
                        onClick={onConfirm}
                        type="button"
                    >
                        Thêm vào giỏ hàng
                    </button>
                </div>
            </div>
        </div>
    );
}
